import dayjs from 'dayjs'
import React from 'react'

import s from './styles.module.scss'

import ProposalSpecialConditions from '../proposal-special-conditions/ProposalSpecialConditions'
import {
  ClientRequestContactOutputDto,
  HouseContext,
} from '../../../../../lib/graphql'
import { Container } from '../../../../layout/container'

const ProposalSpecialConditionsConfirmated = ({
  specialConditions,
  confirmationDate,
  user,
  containerStyle = {},
}: {
  specialConditions?: HouseContext['specialConditions']
  user?: ClientRequestContactOutputDto | null
  confirmationDate: Date
  containerStyle?: React.CSSProperties
}) => {
  return (
    <div style={{ breakInside: 'avoid', paddingTop: 20 }}>
      <Container classNameContent={s.container} style={containerStyle}>
        <>
          <h1>
            Contrat d’application à la Convention générale pour les Voyages
            d’affaires
          </h1>
          <h2>PREAMBULE</h2>
          <p>
            Naboo est une société dont l’activité est la réservation de
            séminaires professionnels. Le Client souhaite avoir recours aux
            services de Naboo pour la réservation de ses séminaires
            d’entreprises au bénéfice de ses employés.
          </p>
          <p>
            Le Client a ainsi désigné Naboo comme partenaire non exclusif à cet
            effet.
          </p>
          <p>
            Dans ce cadre, les Parties ont conclu une Convention générale de
            Voyage d’affaires établissant les caractéristiques générales des
            Prestations de Voyages d’affaires dont les modalités doivent être
            précisées, pour chacun des Voyages d’affaires, au sein de Contrats
            d’application.
          </p>
          <p>
            Le présent Contrat d’application est régi par la Convention générale
            de Voyage d’affaires et précise les conditions et modalités des du
            présent Voyage d’affaires dont les Prestations de Voyages d’affaires
            sont rendues par les Partenaires visés dans le présent Contrat
            d’application et pour lesquels Naboo agit au nom et pour le compte,
            en qualité de mandataire, au titre des présentes.
          </p>
          <h2>ARTICLE 1 – DEFINITIONS</h2>
          <p>
            Les termes précédés d’une majuscule ont l’acception qui leur est
            donnée au sein de la Convention.
          </p>
          <h2>ARTICLE 2 – OBJET</h2>
          <p>
            Le présent Contrat d’application a pour objet de préciser les
            conditions et modalités d’exécution par les Partenaires du Voyage
            d’affaires visés en préambule des présentes.
          </p>
          <h2>
            ARTICLE 3 – CONDITIONS ET MODALITES D’EXECUTION DES PRESTATIONS DE
            VOYAGES D’AFFAIRES
          </h2>
          <p>
            La Synthèse des prestations fournies par des tiers (ci-dessus) est
            exhaustive, et contient à la fois les prestations, leur quantité, le
            valeur unitaire, et leur valeur totale, en HT et TTC.
          </p>
          <p>
            Au-delà des conditions économiques, voici les autres conditions et
            modalités d’exécution telles que fournies par le Partenaire
            hébergeant votre Voyage d’Affaires :
          </p>

          <ProposalSpecialConditions specialConditions={specialConditions} />

          <div className={s.conclusion}>
            <p>
              EN FOI DE QUOI, le Contrat d’application a été conclu par les
              Parties ou leurs représentants dûment habilités à la date indiquée
              ci-après
            </p>
            <div className={s.signContainer}>
              <div className={s.signWrapper}>
                <p>Pour le Mandataire</p>
                <p>
                  <strong>Antoine Servant</strong>
                </p>
                <p>Signé sur www.naboo.app</p>
                <p>Le {dayjs(confirmationDate).format('DD MMMM YYYY')}</p>
              </div>
              <div className={s.signWrapper}>
                <p>Pour le Mandant</p>
                <p>
                  <strong>
                    {user?.firstname} {user?.lastname}
                  </strong>
                </p>
                <p>Signé sur www.naboo.app</p>
                <p>Le {dayjs(confirmationDate).format('DD MMMM YYYY')}</p>
                {user?.mail && <p>Depuis l`espace client : {user?.mail}</p>}
              </div>
            </div>
          </div>
        </>
      </Container>
    </div>
  )
}

export default ProposalSpecialConditionsConfirmated
